import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';

import UserFormGroup from './UserFormGroup';
import GenericDialog from '../GenericDialog';
import ContentBox from '../layout/ContentBox';
import { parseToQuipUserData } from '../utilities/UserUtility';
import { AppActionTypes, QuipUser } from '../../redux/types';
import ApiClient from '../../loopback/apiClient';

type Props = {
  isOpen: boolean;
  userData: QuipUser;
  onClose: (requireRefresh?: boolean) => void;
  saveUserData?: (updatedUser: QuipUser) => void;
  showNotification: (message: string | React.ReactElement) => AppActionTypes;
  locale: string;
  lockCountry?: boolean;
}
class UserEditDialog extends Component<Props> {
  onSave = async (values: Record<string, any>): Promise<void> => {
    const {
      userData, onClose, showNotification, saveUserData,
    } = this.props;
    const modifiedUserData = parseToQuipUserData(values);
    const updatedUser = { ...userData, ...modifiedUserData };
    try {
      await ApiClient.updateUser(updatedUser);
      if (saveUserData) {
        saveUserData(updatedUser);
      }
      onClose(true);
      showNotification(<FormattedMessage id="genericSaveMessage" />);
    } catch (e: any) {
      throw Error(e);
    }
  };

  render() {
    const {
      userData,
      isOpen,
      onClose,
      locale,
      lockCountry,
    } = this.props;
    if (!userData) { return null; }
    return (
      <GenericDialog isOpen={isOpen}>
        <ContentBox title={<FormattedMessage id="userDetails.editUser" />}>
          <UserFormGroup
            userDetails={userData}
            onClose={onClose}
            onDoSave={this.onSave}
            locale={locale}
            lockCountry={lockCountry}
          />
        </ContentBox>
      </GenericDialog>
    );
  }
}

export default UserEditDialog;
